var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.drawChart)?_c('div',{staticClass:"text-center"},[_c('GChart',{attrs:{"type":"PieChart","data":_vm.ocupacionTotal,"options":_vm.chartOptions}})],1):_vm._e(),_c('h5',[_vm._v("*El TOTAL DISPONIBLE refleja el aforo máximo de todas las zonas menos las butacas confirmadas/cerradas")])])
}
var staticRenderFns = []

export { render, staticRenderFns }